import React from 'react';
import PropTypes from 'prop-types';
import { Icon, COLORS } from '@livecommerce/design-system';
import { Button, IconWrapper, TextWrapper, Title, Subtitle, StyledIcon, ChevronWrapper, TitleRow, Pill } from './styles.js';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { DASHBOARD_PRODUCTS } from 'constants/products.js';

const listOfColoredIcons = ['onDemandProduct', 'showsProduct', 'callsProduct', 'chatProduct'];

const ProductSwitcher = ({ isSelected, product, onSelect, customSubtitle = null, ...props }) => {
  const { t } = useLocalization();
  const { icon, translationLabel, translationSubtitle, isBeta = false } = DASHBOARD_PRODUCTS[product];

  const iconProps = {
    name: icon,
    height: 21,
    width: 21,
  };

  return (
    <Button
      id="product-switcher-button"
      onClick={onSelect}
      aria-pressed={isSelected}
      color={listOfColoredIcons.includes(icon) ? 'transparent' : 'white'}
      layout="position"
      {...props}
    >
      <IconWrapper>
        <Icon {...iconProps} />
      </IconWrapper>
      <TextWrapper>
        <TitleRow>
          <Title>{t(translationLabel)}</Title>
          {isBeta && (
            <Pill backgroundColor={COLORS.orange_500} color={COLORS.light_100}>
              {t('genericLabels.beta')}
            </Pill>
          )}
        </TitleRow>
        <Subtitle>{customSubtitle || t(translationSubtitle)}</Subtitle>
      </TextWrapper>
      {!props['aria-controls'] && isSelected && (
        <StyledIcon>
          <Icon name="checkmark" color={COLORS.dark_700} />
        </StyledIcon>
      )}
      {props['aria-controls'] && (
        <ChevronWrapper
          initial={{ rotate: isSelected ? 0 : -180 }}
          animate={{ rotate: isSelected ? 0 : -180 }}
          transition={{ duration: 0.25, ease: 'easeInOut' }}
        >
          <Icon name="chevron" color={COLORS.light_000} />
        </ChevronWrapper>
      )}
    </Button>
  );
};

ProductSwitcher.propTypes = {
  isSelected: PropTypes.bool,
  product: PropTypes.oneOf(Object.keys(DASHBOARD_PRODUCTS)),
  onSelect: PropTypes.func.isRequired,
};

export default ProductSwitcher;
